import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Input,
  Button,
  Table,
} from "reactstrap";

import { ApiContext } from "../../contexts/ApiContext";
import { useNotification } from "../../contexts/NotificationContext";
import AccountService from "../../service/account.service";

const OrderStatusSettings = () => {
  const { account } = useContext(ApiContext);
  const { notify } = useNotification();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (account?.id) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.id]);

  const load = async () => {
    setLoading(true);
    try {
      const data = await AccountService.getOrderStatuses(account.id);
      setItems((data || []).slice().sort((a, b) => a.order - b.order));
    } catch (err) {
      console.error(err);
      notify("tr", "danger", "Erro ao carregar status", "icon-alert-circle-exc");
    } finally {
      setLoading(false);
    }
  };

  const updateItem = (status, patch) => {
    setItems((prev) => prev.map((s) => (s.status === status ? { ...s, ...patch } : s)));
  };

  const move = (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= items.length) return;
    const next = items.slice();
    const tmp = next[index];
    next[index] = next[target];
    next[target] = tmp;
    setItems(next.map((s, i) => ({ ...s, order: i })));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = items.map((s, i) => ({
        status: s.status,
        label: s.label,
        order: i,
        active: s.active,
      }));
      await AccountService.updateOrderStatuses(account.id, payload);
      notify("tr", "success", "Status atualizados!", "icon-check-2");
    } catch (err) {
      console.error(err);
      notify("tr", "danger", "Erro ao salvar status", "icon-alert-circle-exc");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Status do pedido</CardTitle>
              <p className="card-category">
                Ative, renomeie e ordene os status que sua conta utiliza.
              </p>
            </CardHeader>
            <CardBody>
              {loading && <div>Carregando...</div>}
              {!loading && (
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th style={{ width: 80 }}>Ativo</th>
                      <th>Rótulo</th>
                      <th style={{ width: 140 }}>Ordem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((s, index) => (
                      <tr key={s.status}>
                        <td>
                          <Input
                            type="checkbox"
                            style={{ position: "static", margin: 0 }}
                            checked={s.active}
                            onChange={(e) => updateItem(s.status, { active: e.target.checked })}
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            value={s.label}
                            onChange={(e) => updateItem(s.status, { label: e.target.value })}
                          />
                          <small className="text-muted">{s.status}</small>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            color="link"
                            onClick={() => move(index, -1)}
                            disabled={index === 0}
                          >
                            <i className="tim-icons icon-minimal-up" />
                          </Button>
                          <Button
                            size="sm"
                            color="link"
                            onClick={() => move(index, 1)}
                            disabled={index === items.length - 1}
                          >
                            <i className="tim-icons icon-minimal-down" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
            <CardFooter>
              <Button className="btn-fill" color="primary" onClick={handleSave} disabled={saving}>
                {saving ? "Salvando..." : "Salvar"}
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default OrderStatusSettings;
